import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5CA327',
    },
    secondary: {
      main: '#8d288e',
    },
  },
});

export default theme;